"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCanvasState = exports.withCanvas = exports.CanvasStateProvider = exports.CanvasStateContext = exports.CanvasProvider = exports.CanvasContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _Canvas = require("./Canvas");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CanvasContext = exports.CanvasContext = /*#__PURE__*/_react["default"].createContext(null);
var CanvasProvider = exports.CanvasProvider = function CanvasProvider(_ref) {
  var canvas = _ref.canvas,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(CanvasContext.Provider, {
    value: canvas
  }, children);
};
var withCanvas = exports.withCanvas = function withCanvas(Component) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(CanvasContext.Consumer, null, function (canvas) {
      return canvas && /*#__PURE__*/_react["default"].createElement(Component, _extends({
        canvas: canvas
      }, props));
    });
  };
};
var CanvasStateContext = exports.CanvasStateContext = /*#__PURE__*/_react["default"].createContext({});
var CanvasStateProvider = exports.CanvasStateProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(CanvasStateProvider, _React$Component);
  var _super = _createSuper(CanvasStateProvider);
  function CanvasStateProvider() {
    var _this;
    _classCallCheck(this, CanvasStateProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    // get the initial state of the canvas
    _defineProperty(_assertThisInitialized(_this), "state", _this.props.canvas ? _this.props.canvas.getState() : {});
    _defineProperty(_assertThisInitialized(_this), "onChange", function (canvas) {
      if (!canvas) {
        return;
      }
      // for the first change event the state should be updated immediately
      if (!_this._firstChangeDone) {
        _this._firstChangeDone = true;
        _this.setState(canvas.getState());
      } else {
        // the other updates should be debounced to avoid performance problems of frequent re-rendering
        _this.onChangeDebounced(canvas);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onChangeDebounced", (0, _debounce["default"])(function (canvas) {
      _this.setState(canvas.getState());
    }, 10));
    _defineProperty(_assertThisInitialized(_this), "resetFirstChange", (0, _debounce["default"])(function () {
      _this._firstChangeDone = false;
    }, 100));
    return _this;
  }
  _createClass(CanvasStateProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var canvas = this.props.canvas;
      this.initEvents(canvas);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevCanvas = prevProps.canvas;
      var canvas = this.props.canvas;
      if (prevCanvas !== canvas) {
        this.removeEvents(prevCanvas);
        this.onChange(canvas);
        this.initEvents(canvas);
      }

      // after a state update the _firstChangeDone should be reset
      if (this._firstChangeDone) {
        this.resetFirstChange();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var canvas = this.props.canvas;
      this.removeEvents(canvas);
    }
  }, {
    key: "initEvents",
    value: function initEvents(canvas) {
      if (canvas) {
        canvas.on(_Canvas.CanvasEvents.OnChange, this.onChange);
        canvas.on(_Canvas.CanvasEvents.OnObjectChange, this.onChange);
        canvas.on(_Canvas.CanvasEvents.OnSizeChange, this.onChange);
      }
    }
  }, {
    key: "removeEvents",
    value: function removeEvents(canvas) {
      if (canvas) {
        canvas.off(_Canvas.CanvasEvents.OnChange, this.onChange);
        canvas.off(_Canvas.CanvasEvents.OnObjectChange, this.onChange);
        canvas.off(_Canvas.CanvasEvents.OnSizeChange, this.onChange);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(CanvasStateContext.Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);
  return CanvasStateProvider;
}(_react["default"].Component);
_defineProperty(CanvasStateProvider, "propTypes", {
  canvas: _propTypes["default"].instanceOf(_Canvas.AbstractCanvas)
});
_defineProperty(CanvasStateProvider, "defaultProps", {
  canvas: null
});
var withCanvasState = exports.withCanvasState = function withCanvasState(Component) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(CanvasStateContext.Consumer, null, function (state) {
      return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, state, props));
    });
  };
};